module.exports = __webpack_public_path__ + "static/img/agree.b2f5059.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/person/agree.png
// module id = /URj
// module chunks = 1